/*
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2021-11-02 09:54:41
 * @LastEditors: shenlin
 * @LastEditTime: 2021-11-05 09:39:37
 */

/** 直播运营接口 */
const BASE_URL = '/lishui-gov'
const BASE = '/dev-api'
import request from '@/common/api/request'
// 直播运营列表
export const listLiveOperate = params => request(BASE_URL + '/govliveData/listLiveOperate', { params })
// 所有直播
export const listAllLiveData = params => request(BASE_URL + '/govliveData/listAllLiveData', { params })
// 文件上传
export const uploadImg = process.env.VUE_APP_BASE_API + BASE_URL + '/api/file/upload'
// 直播运营新增修改
export const insertOrUpdateLiveOperate = data => request.post(BASE_URL + '/govliveData/insertOrUpdateLiveOperate', data)
// 删除直播运营
export const deleteLiveData = params => request(BASE_URL + '/govliveData/deleteLiveOperate', { params })
